import React from 'react';
import { RegisterConfigPage } from './RegisterConfigPage';

export const EvidenceConfigPage: React.FC = () => {
  return <RegisterConfigPage kind="evidence" />;
};
